import RequestAbstract from '../abstract';

export default class P2PEvents extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/p2p-events';
    }
}
